<template>
	<div>
		<component v-for="(item, index) in moreItems" :key="index" :is="{ template: item }" />
		<button
			type="submit"
			v-if="start <= totalPages && !loading"
			class="btn btn-primary"
			@click.prevent="loadItems(start)"
		>
			{{ messages.load_more }}
		</button>
		<div v-if="loading">
			<div class="row">
				<div class="col-xl-6">
					<div
						class="loadmore"
						style="height: 200px; width: 100%; border: 1px solid #aaa; filter: blur(5px); margin-right: 30px;"
					></div>
				</div>
				<div class="col-xl-6">
					<div
						class="loadmore"
						style="height: 200px; width: 100%; border: 1px solid #aaa; filter: blur(5px);"
					></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, computed } from 'vue';
import axios from 'axios';

const props = defineProps(['url', 'total', 'count', 'language']);
const moreItems = ref([]);
const start = ref(2);
const loading = ref(false);
const messages = window.messages;

const loadItems = async (page) => {
	loading.value = true;
	try {
		const res = await axios.get(`/${props.url}/${props.language}/${page}`, {
			headers: {
				'X-Requested-With': 'XMLHttpRequest'
			}
		});
		const scroll = window.scrollY;
		start.value++;
		moreItems.value.push(res.data);
		loading.value = false;
		// setTimeout(() => {
		//   window.scrollTo({ top: scroll, left: 0, behavior: 'smooth' });
		// }, 1, scroll);
	} catch (error) {
		loading.value = false;
	}
};

const totalPages = computed(() => {
	return Math.round((props.total + props.count / 2) / props.count);
});

const loadedItems = computed(() => {
	const loaded = props.count * start.value - props.count;
	return loaded > props.total ? props.total : loaded;
});

const pageInfo = computed(() => {
	return `${loadedItems.value} / ${props.total}`;
});
</script>

<style scoped>
bottom {
	margin-bottom: 20px;
}
.lds-ring {
	display: inline-block;
	position: relative;
	width: 80px;
	height: 80px;
}
.lds-ring div {
	box-sizing: border-box;
	display: block;
	position: absolute;
	width: 64px;
	height: 64px;
	margin: 8px;
	border: 8px solid #fff;
	border-radius: 50%;
	animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
	border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
	animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
	animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
	animation-delay: -0.15s;
}
@keyframes lds-ring {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>
